export default __webpack_public_path__ + "static/media/icn-message-warning.8fe1188b.svg";